export const CREDIT_LIMIT_COPY = {
  sectionTitle: 'Pengaturan Limit Kredit',
  policy: {
    label: 'Apakah perusahaan Anda menerapkan limit kredit untuk Astro?',
    description:
      'Limit kredit adalah batas transaksi yang dapat berjalan sebelum pembayaran dari Astro diterima.',
    optionYes: 'Ya',
    optionNo: 'Tidak',
    adaDisabledTooltip:
      'Pilihan "Ya" pada Credit Limit bisa dipilih untuk Terms of Payment selain CBD',
  },
  type: {
    label: 'Jenis Limit Kredit',
    description:
      'Pilih jenis limit kredit yang berlaku untuk transaksi dengan Astro. Anda dapat memilih lebih dari satu.',
  },
  nominal: {
    label: 'Limit Berdasarkan Nominal',
    description: 'Batas maksimum total nilai transaksi yang belum dibayar oleh Astro.',
    placeholder: 'Nominal Limit Kredit',
  },
  invoice: {
    label: 'Limit Berdasarkan Jumlah Invoice',
    description: 'Batas maksimum jumlah invoice yang belum dibayar oleh Astro.',
    placeholder: 'Maksimum Invoice belum dibayar',
  },
  basis: {
    label: 'Kapan Limit Kredit Mulai Terpakai',
    description:
      'Pilih kapan transaksi mulai diperhitungkan sebagai penggunaan limit kredit perusahaan Anda.',
    grn: {
      label: 'Saat barang diterima Astro (GRN)',
      description:
        'Limit kredit akan terpakai setelah barang diterima dan tercatat GRN oleh Astro, meskipun invoice belum diajukan.',
    },
    invoiceSubmitted: {
      label: 'Saat invoice diajukan ke Astro',
      description:
        'Limit kredit akan terpakai setelah invoice diajukan. Barang yang sudah diterima tetapi belum ditagihkan belum menggunakan limit kredit.',
    },
  },
  document: {
    label: 'Dokumen Ketentuan Limit Kredit',
    description:
      'Unggah dokumen resmi perusahaan yang menjelaskan ketentuan limit kredit untuk Astro.',
  },
  review: {
    nominalValueLabel: 'Nilai Limit Nominal',
    invoiceValueLabel: 'Nilai Limit Jumlah Invoice',
  },
  validation: {
    minTypeSelection: 'Pilih minimal 1 tipe limit kredit',
    nominalRequired: 'Limit nominal wajib diisi',
    nominalMinAmount: 'Limit nominal harus lebih besar dari 0',
    nominalMaxAmount: 'Limit Nominal tidak boleh melebihi Rp 9.999.999.999.999',
    invoiceCountRequired: 'Limit jumlah invoice wajib diisi',
    basisRequiresNominal: 'Pilih Limit Nominal untuk menggunakan dasar PO dan Invoice',
  },
} as const

export const CREDIT_LIMIT_DOCUMENT_REQUIRED_MESSAGE = `${CREDIT_LIMIT_COPY.document.label} wajib di-upload`
